import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { applyLocale } from "./lib/i18n";
import { applyTheme, preferredTheme } from "./lib/theme";
import { createAppRouter } from "./router";
import "./styles/globals.css";

// Before the first paint, so a dark-theme viewer never sees a light flash.
applyTheme(preferredTheme());
applyLocale();
const router = createAppRouter();
const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
